import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  Container,
  Button,
} from "shards-react";
import { models } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import styled from "styled-components";
import * as htmlToImage from "html-to-image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import baseUrl from "config/baseUrl";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import useToken from "shared/hook/useToken";
import html2canvas from "html2canvas";
import useCurrentUser from "shared/hook/useCurrentUser";
import {
  faCloudArrowDown,
  faPen,
  faGauge,
  faMagnifyingGlass,
  faPuzzlePiece,
} from "@fortawesome/free-solid-svg-icons";
import MenuBar from "shared/components/MenuBar/MenuBar";
import Bg_Indicators from "shared/assets/img/bg_indicators.png";
import {
  Loading,
  // PowerBi,
  ContentDetail,
  ModalDownLoadReport,
} from "views/Indicators/components";
import { useTranslation } from "react-i18next";
// import { FunctionalComponentToPrint } from "views/Indicators/components/PowerBi";

import "react-quill/dist/quill.snow.css";

const download = require("downloadjs");
const axios = require("axios").default;

const StyledContent = styled.div`
  background-image: url(${Bg_Indicators});
  margin-left: -15px;
  margin-right: -15px;
  background-repeat: no-repeat;
  background-position: 50% 0;
  background-size: cover;
`;
const StyledContentBody = styled.div`
  background-color: #1968bcab;
  min-height: calc(100vh - 171px);
  margin-left: -15px;
  margin-right: -15px;
`;
const StyledTabContent = styled.div`
  margin-top: 15px;
  background-color: #fff;
  border-radius: 10px !important;
`;
const StyledTabPane = styled.div`
  padding: 20px;
  min-height: calc(100vh - 280px);
  margin-bottom: 20px;
`;

const IndicatorsDetail = (props) => {
  const { match } = props;
  const { token } = useToken();
  const { t, i18n } = useTranslation();
  const { curruntUser } = useCurrentUser();
  const powerbiRef = useRef(null);
  const componentRef = useRef(null);
  const onBeforeGetContentResolve = useRef(null);
  const [loading, setLoading] = useState(false);

  const componentDetailRef = useRef();
  const [text, setText] = useState("old boring text");

  const detailRef = useRef(null);
  const paramsId = match.params.id;
  const [dataindicators, setDataindicators] = useState(null);
  const [status, setStatus] = useState(0);
  const [openModalDownLoadReport, setOpenModalDownLoadReport] = useState(false);
  const [contentSettingId, setContentSettingId] = useState(null);
  const [contentSettingName, setContentSettingName] = useState(null);
  const [contentSettingNameEN, setContentSettingNameEN] = useState(null);
  const [contentSubSettingId, setContentSubSettingId] = useState(null);
  const [contentSubSettingName, setContentSubSettingName] = useState(null);
  const [contentSubSettingNameEN, setContentSubSettingNameEN] = useState(null);
  const [indicatorsDatasetSettingId, setIndicatorsDatasetSettingId] = useState(
    null
  );
  const [isPermission, setIsPermission] = useState();
  const [report, setReport] = useState();
  const [embed, setEmbed] = useState();
  const [
    indicatorsDatasetSettingName,
    setIndicatorsDatasetSettingName,
  ] = useState(null);
  const [
    indicatorsDatasetSettingNameEN,
    setIndicatorsDatasetSettingNameEN,
  ] = useState(null);

  const [sampleReportConfig, setReportConfig] = useState({
    type: "report",
    embedUrl:
      dataindicators != null && dataindicators.data.length > 0
        ? i18n.language === "th"
          ? dataindicators.data[0].link
          : dataindicators.data[0].linkEN || dataindicators.data[0].link
        : undefined,
    tokenType: models.TokenType.Embed,
    accessToken: undefined,
    settings: undefined,
  });
  //print
  const handleAfterPrint = useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  const handleBeforePrint = useCallback(() => {
    console.log("`onBeforePrint` called");
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    console.log("`onBeforeGetContent` called");
    setLoading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      setTimeout(() => {
        onBeforeGetContentResolve.current = resolve;
        setLoading(false);
        setText("New, Updated Text!");
        resolve();
      }, 3000);
    });
  }, [setLoading, setText]);

  useEffect(() => {
    if (
      text === "New, Updated Text!" &&
      typeof onBeforeGetContentResolve.current === "function"
    ) {
      onBeforeGetContentResolve.current();
    }
  }, [onBeforeGetContentResolve.current, text]);

  const reactToPrintContent = useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const reactToPrintContentDetail = useCallback(() => {
    return componentDetailRef.current;
  }, [componentDetailRef.current]);

  const reactToPrintTrigger = useCallback(() => {
    return (
      <Button className="btn-success">
        {t("common:indicatorsDetail.ButtonDownloadInformation")}
      </Button>
    );
  }, []);

  useEffect(() => {
    if (paramsId) {
      var data = JSON.stringify({
        params: {
          indicatorsDatasetSettingId: paramsId,
        },
        show: 5,
        page: 1,
        orderBy: "indicatorsDatasetSettingId",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/contentsubdetaillistshow`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setDataindicators(response.data);
          setReportConfig({
            type: "report",
            embedUrl:
              response.data != null && response.data.data.length > 0
                ? response.data.data[0].link
                : undefined,
            tokenType: models.TokenType.Embed,
            accessToken: undefined,
            settings: undefined,
          });
          setContentSettingId(response.data.data[0].contentSettingId);
          setContentSettingName(response.data.data[0].contentSettingName);
          setContentSettingNameEN(response.data.data[0].contentSettingNameEN);
          setContentSubSettingId(response.data.data[0].contentSubSettingId);
          setContentSubSettingName(response.data.data[0].contentSubSettingName);
          setContentSubSettingNameEN(
            response.data.data[0].contentSubSettingNameEN
          );
          setIndicatorsDatasetSettingId(
            response.data.data[0].indicatorsDatasetSettingId
          );
          setIndicatorsDatasetSettingName(
            response.data.data[0].indicatorsDatasetSettingName
          );
          setIndicatorsDatasetSettingNameEN(
            response.data.data[0].indicatorsDatasetSettingNameEN
          );
          // }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [indicatorsDatasetSettingId]);

  useEffect(() => {
    if (token) {
      var data = JSON.stringify({
        params: {
          id: paramsId,
        },
        show: 1,
        page: 1,
        orderBy: "indicatorsDatasetSettingId",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/user/usersPermissionList`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setIsPermission(response.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  const checkTab = ["50", "51", "52", "53", "54"];
  const tab = [
    {
      title: t("common:indicatorsDetail.Performance"),
      icon: <FontAwesomeIcon icon={faGauge} />,
    },
    {
      title: t("common:indicatorsDetail.IntroductionLinkage"),
      icon: <FontAwesomeIcon icon={faMagnifyingGlass} />,
    },
    {
      title: t("common:indicatorsDetail.DefinitionMeaning"),
      icon: <FontAwesomeIcon icon={faPen} />,
    },
    {
      title: t("common:indicatorsDetail.KPIStructure"),
      icon: <FontAwesomeIcon icon={faPuzzlePiece} />,
    },
    {
      title: t("common:indicatorsDetail.DownloadInformation"),
      icon: <FontAwesomeIcon icon={faCloudArrowDown} />,
      hidden: checkTab.includes(paramsId),
    },
  ];

  const selectTabs = (status) => {
    setStatus(status);
  };

  const downloadDetail = () => {
    // htmlToImage
    //   .toPng(document.getElementById("downloadData"))
    //   .then(function(dataUrl) {
    //     download(dataUrl, "downloadData.jpg");
    //   });
    html2canvas(document.querySelector("#bi-dowload")).then((canvas) => {
      document.body.appendChild(canvas);
    });
  };

  let indicators = [];
  if (dataindicators != null && dataindicators.data.length > 0) {
    indicators = dataindicators.data[0];
  }
  const menu = [
    {
      path: "/",
      title:
        i18n.language === "th"
          ? contentSettingName
          : contentSettingNameEN || contentSettingName,
    },
    {
      path: `/indicators/${contentSubSettingId}`,
      title:
        i18n.language === "th"
          ? contentSubSettingName
          : contentSubSettingNameEN || contentSubSettingName,
    },
    {
      path: `/indicators/detail/${indicatorsDatasetSettingId}`,
      title:
        i18n.language === "th"
          ? indicatorsDatasetSettingName
          : indicatorsDatasetSettingNameEN || indicatorsDatasetSettingName,
    },
  ];
  const eventHandlersMap = new Map([
    [
      "loaded",
      function() {
        console.log("Report has loaded");
      },
    ],
    [
      "rendered",
      function() {
        console.log("Report has rendered");

        // Update display message
        // setMessage("The report is rendered");
      },
    ],
    [
      "error",
      function(event) {
        if (event) {
          console.error(event.detail);
        }
      },
    ],
  ]);

  // const isCheckPermission = (isPermission && isPermission.length > 0 ? true : true);
  const isCheckPermission = (permiss) => {
    if (isPermission && isPermission.length) {
      const { someViewAndDownload, viewAndDownload } = isPermission[0];
      if (permiss === "someViewAndDownload") {
        return someViewAndDownload === 1;
      } else if (permiss === "viewAndDownload") {
        return viewAndDownload === 1;
      }
    } else {
      return true;
    }
  };

  const onsaveDetailBI = (getReport) => {
    if (getReport) {
      var myWindow = window.open("", "", 'width="1024" height="612"');
      var contentHtml =
        '<div style="text-align: center; width: fit-content; margin: 0 auto; position: relative;">';
      contentHtml +=
        '<iframe width="1024" height="612" src="' +
        getReport +
        '" frameborder="0" allowFullScreen="true"> </iframe>';
      contentHtml +=
        '<button type="button" onclick="window.print()" style="display: block; margin: 0 auto; position: absolute; bottom: 8px; right: 90px; border: none; cursor: pointer;">';
      contentHtml +=
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">';
      contentHtml += '<path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>';
      contentHtml +=
        '<path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"/>';
      contentHtml += "</svg>";
      contentHtml += t("common:indicatorsDetail.ButtonDownloadPowerBI");
      contentHtml += "</button>";
      contentHtml += "</div>";
      myWindow.document.write(contentHtml);
      myWindow.document.close();
    }
  };

  const handlePrint = useReactToPrint({
    content: () => componentDetailRef.current,
  });

  // if(report){

  //   // var reportId = report.getId();
  //   console.log(report)
  // }
  return (
    <>
      <Container>
        <MenuBar menu={menu} mode="indicators" />
      </Container>
      {dataindicators != null ? (
        <StyledContent>
          <StyledContentBody>
            <Container style={{ padding: "20px 0" }}>
              <Row className="indicatorsHeader">
                <Col>
                  <h5 className="color-white">
                    {i18n.language === "th"
                      ? indicators.indicatorsDatasetSettingName
                      : indicators.indicatorsDatasetSettingNameEN ||
                        indicators.indicatorsDatasetSettingName}
                  </h5>
                  <div className="color-white">
                    {t("common:indicatorsDetail.ResponsibleAgency")} :
                    <span style={{ marginLeft: "10px" }}>
                      {i18n.language === "th"
                        ? indicators.indicatorsAgencySettingName
                        : indicators.indicatorsAgencySettingNameEN ||
                          indicators.indicatorsAgencySettingName}
                    </span>
                  </div>
                </Col>
              </Row>
              <hr style={{ borderColor: "#D0D0D0" }} />
              <Row className="indicatorsTab">
                <Col>
                  <Nav tabs className="tab-menu">
                    {tab
                      .filter((item) => !item.hidden)
                      .map((item, key) => (
                        <NavItem key={key}>
                          <NavLink
                            active={status === key ? true : false}
                            onClick={() => selectTabs(key)}
                          >
                            {item.icon}
                            {item.title}
                          </NavLink>
                        </NavItem>
                      ))}
                  </Nav>
                </Col>
              </Row>
              <Row>
                <Col>
                  <StyledTabContent className="tab-content">
                    {status === 0 && (
                      <StyledTabPane>
                        <div className="bold">
                          <span style={{ marginRight: "20px" }}>
                            {t("common:indicatorsDetail.Performance")}
                          </span>
                        </div>
                        <hr />
                        
                        {/* <iframe className="print" src={`${indicators.link}`} /> */}
                        
                        
                        {indicators.link &&
                        indicators.link.includes("app.powerbi.com") ? (
                            <PowerBIEmbed
                              embedConfig={{
                                type: "report",
                                embedUrl:
                                  i18n.language === "th"
                                    ? indicators.link
                                    : indicators.linkEN || indicators.link,
                                tokenType: models.TokenType.Embed,
                                accessToken: undefined,
                                settings: undefined,
                              }}
                              eventHandlers={eventHandlersMap}
                              cssClassName={"report-style-class"}
                              getEmbeddedComponent={(embedObject) => {
                                setReport(embedObject);
                              }}
                            />
                        ) : (
                          <div className="text-center">
                            {t("common:indicatorsDetail.InProgress")}
                          </div>
                        )}

                        {token && isCheckPermission("someViewAndDownload") && (
                          <>
                            <div
                              style={{
                                marginTop: 30,
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              {indicators.link &&
                                indicators.link.includes("app.powerbi.com") && (
                                  <span>
                                    <Button
                                      className="btn-success"
                                      onClick={() => {
                                        // window.print();
                                        // report.print();
                                        // window.open(i18n.language === "th"
                                        // ? indicators.link
                                        // : indicators.linkEN || indicators.link,"mozillaWindow")

                                        onsaveDetailBI(
                                          i18n.language === "th"
                                            ? indicators.link
                                            : indicators.linkEN ||
                                                indicators.link
                                        );
                                      }}
                                    >
                                      {t(
                                        "common:indicatorsDetail.ButtonDownloadPowerBI"
                                      )}
                                    </Button>
                                  </span>
                                )}
                              <span>
                                <Button
                                  className="btn-success"
                                  onClick={() =>
                                    setOpenModalDownLoadReport(true)
                                  }
                                >
                                  {t(
                                    "common:indicatorsDetail.ButtonDownloadReport"
                                  )}
                                </Button>
                              </span>
                            </div>
                            <hr />
                          </>
                        )}

                        {/* <ReactToPrint
                          content={reactToPrintContent}
                          documentTitle="test"
                          onAfterPrint={handleAfterPrint}
                          onBeforeGetContent={handleOnBeforeGetContent}
                          onBeforePrint={handleBeforePrint}
                          removeAfterPrint
                          trigger={reactToPrintTrigger}
                        />
                        {loading && <p className="indicator">Loading...</p>}
                        <FunctionalComponentToPrint
                          ref={componentRef}
                          indicators={indicators}
                        /> */}
                      </StyledTabPane>
                    )}
                    {status === 1 && (
                      <StyledTabPane>
                        <div className="bold">
                          <span style={{ marginRight: "20px" }}>
                            {t("common:indicatorsDetail.IntroductionLinkage")}
                          </span>
                        </div>
                        <hr />
                        {/* {stringToHTML(indicators.importantSource)} */}
                        <div
                          className="ql-editor"
                          dangerouslySetInnerHTML={{
                            __html:
                              i18n.language === "th"
                                ? indicators.importantSource
                                : indicators.importantSourceEN ||
                                  indicators.importantSource,
                          }}
                        />
                      </StyledTabPane>
                    )}
                    {status === 2 && (
                      <StyledTabPane>
                        <div className="bold">
                          <span style={{ marginRight: "20px" }}>
                            {t("common:indicatorsDetail.DefinitionMeaning")}
                          </span>
                        </div>
                        <hr />
                        {/* {stringToHTML(indicators.definition)} */}
                        <div
                          className="ql-editor"
                          dangerouslySetInnerHTML={{
                            __html:
                              i18n.language === "th"
                                ? indicators.definition
                                : indicators.definitionEN ||
                                  indicators.definition,
                          }}
                        />
                      </StyledTabPane>
                    )}
                    {status === 3 && (
                      <StyledTabPane>
                        <div className="bold">
                          <span style={{ marginRight: "20px" }}>
                            {t("common:indicatorsDetail.KPIStructure")}
                          </span>
                        </div>
                        <hr />
                        <div
                          className="ql-editor"
                          dangerouslySetInnerHTML={{
                            __html:
                              i18n.language === "th"
                                ? indicators.formularCalculate
                                : indicators.formularCalculateEN ||
                                  indicators.formularCalculate,
                          }}
                        />
                      </StyledTabPane>
                    )}
                    {status === 4 && (
                      <StyledTabPane>
                        <div className="bold">
                          <span style={{ marginRight: "20px" }}>
                            {t("common:indicatorsDetail.DownloadInformation")}
                          </span>
                        </div>
                        <hr />
                        <div className="print">
                          <ContentDetail
                            ref={componentDetailRef}
                            indicators={indicators}
                          />
                          {indicators.link &&
                            indicators.link.includes("app.powerbi.com") && (
                              <PowerBIEmbed
                                embedConfig={{
                                  type: "report",
                                  embedUrl:
                                    i18n.language === "th"
                                      ? indicators.link
                                      : indicators.linkEN || indicators.link,
                                  tokenType: models.TokenType.Embed,
                                  accessToken: undefined,
                                  settings: undefined,
                                }}
                                eventHandlers={eventHandlersMap}
                                cssClassName={"report-style-class"}
                                getEmbeddedComponent={(embedObject) => {
                                  setReport(embedObject);
                                }}
                              />
                            )}
                        </div>

                        <div className="mb-2">
                          <span>
                            {loading && <p className="indicator">Loading...</p>}

                            {token && isCheckPermission("viewAndDownload") && (
                              <>
                                {/* <ReactToPrint
                                  content={reactToPrintContentDetail}
                                  documentTitle="test"
                                  onAfterPrint={handleAfterPrint}
                                  onBeforeGetContent={handleOnBeforeGetContent}
                                  onBeforePrint={handleBeforePrint}
                                  removeAfterPrint
                                  trigger={reactToPrintTrigger}
                                /> */}
                                <Row>
                                  <Col md="4" className="text-center">
                                    <Button
                                      className="btn-success pull-left"
                                      onClick={() =>
                                        onsaveDetailBI(
                                          i18n.language === "th"
                                            ? indicators.link
                                            : indicators.linkEN ||
                                                indicators.link
                                        )
                                      }
                                    >
                                      {t(
                                        "common:indicatorsDetail.ButtonDownloadPowerBI"
                                      )}
                                    </Button>
                                  </Col>
                                  <Col md="4" className="text-center">
                                    <Button
                                      className="btn-success"
                                      onClick={handlePrint}
                                    >
                                      {t(
                                        "common:indicatorsDetail.ButtonDownloadInformation"
                                      )}
                                    </Button>
                                  </Col>
                                  <Col md="4" className="text-center">
                                    <Button
                                      className="btn-success pull-right"
                                      onClick={() =>
                                        setOpenModalDownLoadReport(true)
                                      }
                                    >
                                      {t(
                                        "common:indicatorsDetail.ButtonDownloadReport"
                                      )}
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            )}
                          </span>
                        </div>
                      </StyledTabPane>
                    )}
                  </StyledTabContent>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <div id="ifmcontentstoprint"></div>
                </Col>
              </Row>
            </Container>
          </StyledContentBody>
        </StyledContent>
      ) : (
        <Loading />
      )}

      {openModalDownLoadReport && (
        <ModalDownLoadReport
          open={openModalDownLoadReport}
          toggle={() => setOpenModalDownLoadReport(false)}
          indicatorsId={indicatorsDatasetSettingId}
        />
      )}
    </>
  );
};

export default IndicatorsDetail;
